import {
  makeStyles,
  Button,
  Typography,
  Box,
  InputLabel,
  OutlinedInput,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import React, { useState } from "react";
import { Rating as RatingStars } from "@material-ui/lab";
import { useParams } from "react-router-dom";
import { reviewFormSchema } from "./reviewform";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { addReview } from "../../../redux-store/shop/shop";
import { backend } from "../../../api";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "10px 0 30px 0",
    transistion: "0.3s linear",
  },
  sectionHeading: {
    fontSize: "24px",
    fontWeight: "600",
  },
  form: {
    margin: "20px 0",
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    width: "120px",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
}));

function Rating(props) {
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const { currentBook, setBook } = props;
  const dispatch = useDispatch();
  const params = useParams();
  const [ratingValue, setRatingValue] = useState(0);
  const handleReviewSubmit = (values) => {
    const newReview = {
      rating: ratingValue,
      comment: values.review,
      customer: currentUser.user._id,
    };
    backend
      .post(`/review/${params.bookId}`, newReview)
      .then(({ data }) => {
        setBook(data.book);
        if (data.message === "Review Created Successfully") {
          Swal.fire({
            title: "Congratulations",
            icon: "success",
            confirmButtonText: "OK",
            text: "Review Posted Successfully",
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.sectionHeading}>Your Ratings</h2>
      <RatingStars
        name="hover-feedback"
        precision="0.5"
        color="secondary"
        defaultValue={0}
        onChange={(event, newValue) => {
          setRatingValue(newValue);
        }}
      />
      {ratingValue === 0 ? (
        <Typography color="error" variant="subtitle2">
          You must have to rate to submit review
        </Typography>
      ) : (
        <></>
      )}
      <Formik
        initialValues={{
          review: "",
        }}
        validationSchema={reviewFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          handleReviewSubmit(values);
          resetForm();
        }}
      >
        {({ errors, touched }) => {
          return (
            <Form className={classes.form}>
              <Box mb={2}>
                <InputLabel style={{ marginBottom: "15px", fontWeight: 600 }}>
                  Your Review
                </InputLabel>
                <Field
                  type="text"
                  name="review"
                  multiline
                  rows={5}
                  as={OutlinedInput}
                  fullWidth
                  error={errors.review}
                  className={classes.inputField}
                />
                <ErrorMessage name="review">
                  {(error) => (
                    <Typography color="error" variant="subtitle2">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              {/* <Box mb={2}>
                                <InputLabel style={{marginBottom:'15px', fontWeight:600}}>Name</InputLabel>
                                <Field type="text" name="name"  as={OutlinedInput} fullWidth error={errors.name} className={classes.inputField} />
                                <ErrorMessage name="name">
                                    {error =><Typography color="error" variant="subtitle2">{error}</Typography>}
                                </ErrorMessage>
                            </Box>
                            <Box mb={2}>
                                <InputLabel style={{marginBottom:'15px', fontWeight:600}}>Email</InputLabel>
                                <Field type="text" name="email" as={OutlinedInput} fullWidth error={errors.email} className={classes.inputField} />
                                <ErrorMessage name="email">
                                    {error =><Typography color="error" variant="subtitle2">{error}</Typography>}
                                </ErrorMessage>
                            </Box> */}
              <Box mb={2} textAlign="center">
                <FormControlLabel
                  control={<Checkbox color="secondary" />}
                  label="Save my name, email, and website in this browser for the next time I comment."
                />
              </Box>
              <Box mb={2} textAlign="center">
                <Button
                  type="submit"
                  className={classes.submitBtn}
                  disabled={ratingValue === 0}
                >
                  Submit
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default Rating;
